import { useTheme as useThemeMui } from '@mui/material';

const useTheme = () => {
  const { palette } = useThemeMui();

  return {
    palette,
    isThemeDark: palette.mode === 'dark',
    isThemeLight: palette.mode === 'light',
  };
};

export default useTheme;
